// All permissions related apis
import instance from "./api";
import { encryptData } from "../helpers/encryptDecrypt";

// Get api for fetching all the permission options
export const fetchPermissions = async () => {
  return await instance.get("/permissions");
};

// Post api for updating user's permissions
export const syncUserPermissions = async (userId, permissionData) => {
  const uId = encryptData(userId);
  return await instance.post(
    `/permissions/sync-user-permission/${uId}`,
    permissionData
  );
};

// Post api for creating a new permission
export const createPermission = async (permissionData) => {
  return await instance.post(`/permissions/create`, permissionData);
};

// Post api for registering a new user to the active organization
export const registerUser = async (credentials) => {
  return await instance.post('/register/organization', credentials);
};